import { memo } from 'react'
const DisplayNFTInfo=({tokenId,currentAccount,accountBalance})=> {

    const displayMain=()=> {
        return (

                <div style={{
                    display: 'flex', flexDirection: 'column', overflowWrap: 'break-word',
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    width: '90vw'
                }}>
                    <p>NFT ID: {tokenId}</p>
                    <p>Account: {currentAccount}</p>
                    <p>Balance: {accountBalance ? accountBalance.toString() : 0}</p>
                </div>

        )
    }

    return displayMain()
}
export default memo(DisplayNFTInfo)